import React, { useState } from "react";
import { Download, Share, Plus, X, MoreVertical } from "lucide-react";

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function InstallPrompt() {
  const [show, setShow] = useState(false);

  if (isStandalone()) {
    return (
      <div data-testid="install-installed" className="rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/10 p-4 text-sm text-[#D4AF37] flex items-center gap-2">
        <Download size={16} /> App added — you're running Darkchata from your home screen.
      </div>
    );
  }

  const ios = isIOS();

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-display text-lg font-semibold flex items-center gap-2">
            <Download size={18} className="text-[#D4AF37]" /> Add to Home Screen
          </p>
          <p className="text-[#A19DB0] text-xs mt-0.5">Add Darkchata to your home screen for a full-screen, app-like experience.</p>
        </div>
        <button onClick={() => setShow((s) => !s)} data-testid="install-app-btn"
          className="shrink-0 rounded-full bg-[#D4AF37] text-black font-semibold px-4 py-2.5 text-sm active:scale-95 transition-transform">
          Show me how
        </button>
      </div>

      {show && (
        <div data-testid="install-help" className="mt-3 rounded-xl border border-white/10 bg-black/30 p-3 text-sm text-[#E9E5F0] relative">
          <button onClick={() => setShow(false)} className="absolute top-2 right-2 text-[#A19DB0]"><X size={15} /></button>

          {ios ? (
            <>
              <p className="font-medium mb-2">On iPhone / iPad (Safari):</p>
              <ol className="space-y-1.5 text-[#A19DB0] text-[13px]">
                <li className="flex items-center gap-2">1. Tap the <Share size={14} className="inline text-[#D4AF37]" /> <b className="text-white">Share</b> button</li>
                <li className="flex items-center gap-2">2. Choose <Plus size={14} className="inline text-[#D4AF37]" /> <b className="text-white">Add to Home Screen</b></li>
                <li>3. Tap <b className="text-white">Add</b> — done!</li>
              </ol>
            </>
          ) : (
            <>
              <p className="font-medium mb-2">On Android (Chrome):</p>
              <ol className="space-y-1.5 text-[#A19DB0] text-[13px]">
                <li className="flex items-center gap-2">1. Tap the <MoreVertical size={14} className="inline text-[#D4AF37]" /> <b className="text-white">menu</b> (top-right of the browser)</li>
                <li className="flex items-center gap-2">2. Tap <Plus size={14} className="inline text-[#D4AF37]" /> <b className="text-white">Add to Home screen</b></li>
                <li>3. Tap <b className="text-white">Add</b> — done!</li>
              </ol>
              <p className="text-[#A19DB0] text-[12px] mt-2">Tip: choose <b className="text-white">Add to Home screen</b> (not "Install app") to skip the Play Protect prompt.</p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
